import { gql, useLazyQuery } from "@apollo/client";

const GET_DESIGNER_APPLICATION_LIST_QUERY = gql`
  query GetDesignerApplicationList($status: DesignerApplicationSteps) {
    getDesignerApplicationList(status: $status) {
      _id
      designerId {
        firstName
        lastName
        aliasId
        email
        accountType
        subscription
        businessName
        businessCity
        businessState
        phoneNumber
      }
      experience {
        id
        title
        company
        startDate
        endDate
        current
        employmentType
        firmSize
      }
      education
      references {
        id
        type
        businessName
        firstName
        lastName
        title
        ProjectType
        email
        phoneNumber
        startDate
        endDate
      }
      businessGoals {
        overview {
          numberOfProjectsLastYear
          totalRevenueLastYear
          numberOfProjectsCurrentYear
          totalRevenueCurrentYear
        }
        projectCapacity {
          largeScale
          smallScale
        }
        challenges
        expectations
      }
      status
      membershipTier
    }
  }
`;

export const useGetDesignerApplicationListQuery = () => {
  const [getDesignerApplicationListQuery, { loading, error, data }] =
    useLazyQuery(GET_DESIGNER_APPLICATION_LIST_QUERY);

  const getDesignerApplicationList = async (
    status?: string | null,
    refresh: boolean = false
  ) => {
    const result = await getDesignerApplicationListQuery({
      variables: { status: status ?? null },
      fetchPolicy: refresh ? "network-only" : "cache-first",
    });
    return result.data?.getDesignerApplicationList ?? [];
  };

  return {
    getDesignerApplicationList,
    loading,
    error,
    data,
  };
};
